import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { Button, Card, Typography } from '../..';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: theme.spacing(3),
  borderRadius: theme.spacing(3),
  width: '100%',
  flex: 1,
  whiteSpace: 'normal',
  textAlign: 'center',
  fontSize: 12,
  padding: theme.spacing(5),
  boxShadow: 'none',
  background: 'var(--background-background-color)',
  border: '1px solid var(--stroke-stroke-primary-color)',
  svg: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

const StyledTitle = styled(Typography)({
  fontSize: 18,
  lineHeight: '28px',
  fontWeight: 600,
  color: 'var(--text-text-primary-color)',
});

export type CTACardProps = {
  icon: ReactNode;
  title?: I18nResources;
  text: I18nResources;
  label: I18nResources;
  className?: string;
  onClick?: () => void;
};

export const CTACard = ({
  icon,
  title,
  text,
  label,
  className,
  onClick,
}: CTACardProps) => {
  const { t } = useI18n();

  return (
    <StyledCard className={className}>
      {icon}
      {title ? <StyledTitle>{t(title)}</StyledTitle> : null}
      <Typography>{t(text)}</Typography>
      <Button
        fullWidth
        size="small"
        variant="contained"
        color="primary"
        onClick={onClick}
      >
        {t(label)}
      </Button>
    </StyledCard>
  );
};
